import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "packages-page" }
const _hoisted_2 = { class: "page-heading" }
const _hoisted_3 = {
  key: 0,
  class: "packages-grid"
}
const _hoisted_4 = { class: "package-media" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 1,
  class: "media-placeholder"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "menu-popover"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "package-details" }
const _hoisted_12 = { class: "builder-name" }
const _hoisted_13 = { class: "package-price" }
const _hoisted_14 = { class: "package-specs" }
const _hoisted_15 = { class: "assigned-lots" }
const _hoisted_16 = {
  key: 0,
  class: "lot-chips"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_19 = {
  key: 2,
  class: "loading-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Home & Land Packages", -1)),
        _createElementVNode("p", null, _toDisplayString($setup.packages.length) + " " + _toDisplayString($setup.packages.length === 1 ? "Package" : "Packages"), 1)
      ]),
      _createElementVNode("button", {
        class: "create-button",
        type: "button",
        onClick: $setup.openCreate
      }, [
        _createVNode($setup["Plus"], { size: 18 }),
        _cache[2] || (_cache[2] = _createElementVNode("span", null, "Create Package", -1))
      ])
    ]),
    (!$setup.loading && $setup.packages.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.packages, (packageRecord) => {
            return (_openBlock(), _createElementBlock("article", {
              class: "package-card",
              key: packageRecord._id
            }, [
              _createElementVNode("div", _hoisted_4, [
                (packageRecord.heroImageUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: packageRecord.heroImageUrl,
                      alt: packageRecord.designName
                    }, null, 8, _hoisted_5))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode($setup["Home"], { size: 48 })
                    ])),
                _createElementVNode("div", {
                  class: "menu-wrapper",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("button", {
                    class: "menu-button",
                    type: "button",
                    "aria-label": "Package actions",
                    onClick: _withModifiers(($event: any) => ($setup.toggleMenu(packageRecord._id)), ["stop"])
                  }, [
                    _createVNode($setup["MoreVertical"], { size: 19 })
                  ], 8, _hoisted_7),
                  ($setup.openMenuId === packageRecord._id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: ($event: any) => ($setup.openEdit(packageRecord))
                        }, [
                          _createVNode($setup["Pencil"], { size: 15 }),
                          _cache[3] || (_cache[3] = _createElementVNode("span", null, "Edit", -1))
                        ], 8, _hoisted_9),
                        _createElementVNode("button", {
                          class: "danger",
                          type: "button",
                          onClick: ($event: any) => ($setup.openDeleteModal(packageRecord))
                        }, [
                          _createVNode($setup["Trash2"], { size: 15 }),
                          _cache[4] || (_cache[4] = _createElementVNode("span", null, "Delete", -1))
                        ], 8, _hoisted_10)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(packageRecord.builderName), 1),
                _createElementVNode("h2", null, _toDisplayString(packageRecord.designName), 1),
                _createElementVNode("div", _hoisted_13, "From " + _toDisplayString($setup.formatPrice(packageRecord.packagePrice)), 1),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", null, [
                    _createVNode($setup["BedDouble"], { size: 15 }),
                    _createTextVNode(" " + _toDisplayString(packageRecord.bedroom), 1)
                  ]),
                  _createElementVNode("span", null, [
                    _createVNode($setup["Bath"], { size: 15 }),
                    _createTextVNode(" " + _toDisplayString(packageRecord.bathroom), 1)
                  ]),
                  _createElementVNode("span", null, [
                    _createVNode($setup["Armchair"], { size: 15 }),
                    _createTextVNode(" " + _toDisplayString(packageRecord.living), 1)
                  ]),
                  _createElementVNode("span", null, [
                    _createVNode($setup["Car"], { size: 15 }),
                    _createTextVNode(" " + _toDisplayString(packageRecord.cars), 1)
                  ]),
                  _createElementVNode("span", null, [
                    _createVNode($setup["MoveHorizontal"], { size: 15 }),
                    _createTextVNode(" " + _toDisplayString(packageRecord.size) + "m²", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", null, "Currently displayed on:", -1)),
                  (packageRecord.lotIds.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packageRecord.lotIds, (lotId) => {
                          return (_openBlock(), _createElementBlock("em", {
                            key: String(lotId)
                          }, "Lot " + _toDisplayString($setup.getLotTitle(lotId)), 1))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("small", _hoisted_17, "No lots assigned"))
                ])
              ])
            ]))
          }), 128))
        ]))
      : (!$setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createVNode($setup["Home"], { size: 52 }),
            _cache[6] || (_cache[6] = _createElementVNode("h2", null, "No packages yet", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("p", null, "Create your first Home & Land package and assign it to lots.", -1)),
            _createElementVNode("button", {
              class: "create-button",
              type: "button",
              onClick: $setup.openCreate
            }, "Create Package")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_19, "Loading packages…")),
    _createVNode($setup["LandSubdivisionPackageModal"], {
      isOpen: $setup.showModal,
      packageData: $setup.editingPackage,
      stages: $setup.stages,
      lots: $setup.lots,
      saving: $setup.saving,
      onClose: $setup.closeModal,
      onSave: $setup.savePackage
    }, null, 8, ["isOpen", "packageData", "stages", "lots", "saving"]),
    _createVNode($setup["LandSubdivisionPackageDeleteModal"], {
      isOpen: Boolean($setup.packageToDelete),
      deleting: $setup.deletingPackage,
      onClose: $setup.closeDeleteModal,
      onConfirm: $setup.confirmDeletePackage
    }, null, 8, ["isOpen", "deleting"])
  ]))
}